import type { NovelItem } from '@app/_proto/Protos/novels';
import type { ClassNameType } from '@app/domains/common/types';
import HomeContent from '@app/domains/home/components/HomeContent';
import { HOME_RECOMMENDATION_BG_STYLES } from '@app/domains/home/styles';
import NovelReviewScore from '@app/domains/novel/components/NovelReviewScore';
import { Paragraph, useHtmlToReact } from '@app/utils/html';
import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

type Props = {
    content: NovelItem | undefined;
    genre: string | undefined;
    isLoading?: boolean;
    genreIdx: number;
};
export default function HomeInitialRecommendedContent({ content, genre, isLoading, genreIdx }: Props) {
    const synopsis = useHtmlToReact(content?.synopsis?.value || '', {
        removeTags: ['hr', 'img'],
        transform: {
            p: Paragraph,
        },
    });

    return (
        <HomeContent content={content} isLoading={isLoading}>
            <div
                className={clsx(
                    'flex h-320 flex-col rounded-12 px-16 pt-16 text-center shadow-ww-text-container',
                    !isLoading && HOME_RECOMMENDATION_BG_STYLES[genreIdx]
                )}
            >
                {!isLoading && <div className="font-set-sb15 text-white">{genre || ''}</div>}
                <ContentImage />
                <VerticalCenter className="pb-12">
                    <HomeContent.Title className="font-set-b16 text-gray-900" />
                    <div className="flex justify-center pt-2">
                        <HomeContent.ReviewScore
                            className="font-set-sb14 text-gray-900"
                            classes={{ goodIcon: 'w-13 h-13', score: 'ml-3' }}
                        >
                            <NovelReviewScore.MedalIcon className="h-16 w-16" />
                        </HomeContent.ReviewScore>
                    </div>
                    {!isLoading && <div className="font-set-r13 pt-2 text-gray-800 line-clamp-2">{synopsis}</div>}
                </VerticalCenter>
            </div>
        </HomeContent>
    );
}

const ContentImage = () => {
    return (
        <div className="pt-12 pb-7">
            <div>
                <div className="relative mx-auto h-163 w-160 px-24">
                    <div className="relative z-10">
                        <HomeContent.Image
                            classes={{ badge: { box: 'h-24 w-24', icon: 'h-16 w-16' } }}
                            srcWidth={112}
                            srcHeight={163}
                        />
                    </div>
                    <div className="bg-ww-home-under-shadow absolute -bottom-9 left-0 z-[1] h-16 w-full" />
                </div>
            </div>
        </div>
    );
};

const VerticalCenter = ({ className, children }: PropsWithChildren<ClassNameType>) => {
    return (
        <div className={clsx('flex grow items-center justify-center', className)}>
            <div>{children}</div>
        </div>
    );
};
